<template>
    <div class="content">
           <input type="password" style="display: none;">
        <img class="login-logo" src="../assets/logo1.png">
        <div class="form-wrapper">
<!--            <img src="../assets/logo.png">-->
            <h3 class="title">节能增效智联平台</h3>
            <el-form :model="ruleForm"
                     :rules="rules2"
                     ref="ruleForm"
                     label-position="left"
                     label-width="0px"
                     class="demo-ruleForm login-container">
                <el-form-item prop="account">
                    <el-input type="text"
                              v-model="ruleForm.account"
                              auto-complete="off"
                              placeholder="账号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input :type="spypassword"
                        @focus="spypassword='password'"
                              v-model="ruleForm.password"
                              auto-complete="off"
                              placeholder="密码"></el-input>
                </el-form-item>
                <!-- <el-radio-group v-model="directory" style="margin-bottom: 10px;display: block;">
                    <el-row>
                        <el-col :span="12" style="text-align: left;">
                            <el-radio :label="'screen'">进入监控图</el-radio>
                        </el-col>
                        <el-col :span="12" style="text-align: right;">
                            <el-radio :label="'system'">管理系统</el-radio>
                        </el-col>
                    </el-row>
                </el-radio-group> -->
                <el-form-item style="width:100%;">
                    <el-button type="primary"
                               style="width:100%;"
                               class="login-button"
                               @click.native.prevent="handleSubmit2"
                               :loading="logining">登录</el-button>
                    <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
                </el-form-item>
                <el-row>
                    <el-col :span="12"
                            style="text-align: left;">
                        <el-checkbox v-model="checked"
                                     class="remember">记住密码</el-checkbox>
                    </el-col>
                    <el-col :span="12"
                            style="text-align: right;">
                        <!--<router-link class="link"-->
                                     <!--tag="span"-->
                                     <!--to="/forgotPwd">忘记密码</router-link>-->
                        <a @click="toForgotPwd" style="text-decoration: none;color: #fff"  href="javascript:;">忘记密码</a>
                    </el-col>
                </el-row>

            </el-form>
        </div>
        <div class="copyright">版权所有：江苏汇励丰节能环保科技有限公司</div>
    </div>

</template>

<script>
import { requestLogin, getRoleMenus,requestLoginL2 } from "@/api/api";
import md5 from 'js-md5'
export default {
    data() {
        return {
            logining: false,
            spypassword: "text",
            ruleForm: {
                account: "",
                password: ""
            },
            rules2: {
                account: [
                    { required: true, message: "请输入账号", trigger: "blur" }
                    //{ validator: validaePass }
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" }
                    //{ validator: validaePass2 }
                ]
            },
            directory: "",
            checked: true
        };
    },
    mounted() {
        this.getCookie()
        // window.onresize = function(){
        // todo
        // }
    },
    methods: {
        handleReset2() {
            this.$refs.ruleForm.resetFields();
        },
        handleSubmit2(ev) {
            var _this = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    //_this.$router.replace('/table');
                    this.logining = true

                    // 记住用户
                    if (this.checked) {
                        // console.log("checked == true");
                        this.setCookie(this.ruleForm.account, this.ruleForm.password, 7)
                    } else {
                        //   console.log("清空Cookie")
                        //清空Cookie
                        this.clearCookie()
                    }


                    var loginParams = {
                        account: this.ruleForm.account,
                        password: md5(this.ruleForm.password)
                    };
                    requestLoginL2(loginParams).then(data => {
                        this.logining = false;
                        let { status, info, user } = data;
                        user = data.data
                        if (status !== 0) {
                            this.$message({
                                message: info,
                                type: "error"
                            });
                            this.logining = false
                        } else {
                            sessionStorage.setItem(
                                "user",
                                JSON.stringify(user)
                            );
                            sessionStorage.setItem(
                                "account",
                                JSON.stringify(user.account)
                            )
                            sessionStorage.setItem(
                                "token",
                                JSON.stringify(user.token)
                            )
                            this.$router.push({ path: "/monitor/map" });
                        }
                    });
                } else {
                    // this.logining = false;
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        //设置cookie
        setCookie(c_name, c_pwd, exdays) {
            var exdate = new Date(); //获取时间
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
            //字符串拼接cookie
            window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
            window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        },
        //读取cookie
        getCookie() {
            this.ruleForm.account = ''
            this.ruleForm.password = ''
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('='); //再次切割
                    //判断查找相对应的值
                    // console.log("rrrrrrrrrrrrrrrrrr",arr2)
                    if (arr2[0] == 'userName') {
                        this.ruleForm.account = arr2[1] //保存到保存数据的地方
                    } else if (arr2[0] == 'userPwd') {
                        this.spypassword = 'password'
                        this.ruleForm.password = arr2[1]
                    }
                }
            }
        },
        //清除cookie
        clearCookie() {
            this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
        },
        toForgotPwd() {
          if(!this.ruleForm.account) {
              this.$message({
                  type: 'warning',
                  message: '请先填写账号'
              })
          }else {
              if(this.ruleForm.account === this.usrCloudUser) {
                  this.$router.push({
                      path:'/forgotPwd',
                      query:{name: this.ruleForm.account }
                  })
              }else {
                  this.$router.push({
                      path:'/forgotPwdL2',
                      query:{name: this.ruleForm.account }
                  })
              }
          }
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    position: relative;
    height: 100%;
    background:  url("../assets/loginbg.png") no-repeat 0 0,linear-gradient(to right,#04278b,#3a71e7);
    background-size: contain;
    box-sizing: border-box;
    .form-wrapper {
        position: absolute;
        top: 50%;
        right: 120px;
        transform: translateY(-50%);
        width: 350px;
        text-align: center;
        .title {
            margin: 10px auto;
            text-align: center;
            color: #fff;
            font-size: 24px;
            line-height: 50px;
        }

        .login-container {
            /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
            -webkit-border-radius: 5px;
            border-radius: 5px;
            -moz-border-radius: 5px;
            background-clip: padding-box;
            padding: 25px 35px 15px 35px;
            background: rgba(250, 250, 250, 0.35);
            // border: 1px solid #eaeaea;
            // box-shadow: 0 0 25px #cac6c6;
            .login-button {
                background-color: #1a46c4;
                border-color: #1a46c4;
            }
            .remember {
                margin: 0px 0px 10px 0px;
            }
            .el-radio,
            .remember,
            .link {
                color: #fff;
                cursor: pointer;
            }
        }
    }
    .copyright {
        position: absolute;
        bottom: 10%;
        right: 170px;
        color: #fff;
        font-size: 10px;
    }
    .login-logo {
        position: absolute;
        top: 15%;
        left: 3%;
        width: 150px;
    }
}
</style>
<style lang="scss">
    .content {
        .login-container {
            .el-checkbox.is-checked .el-checkbox__label{
                color: #1a46c4;
            }
            .el-checkbox__input.is-checked .el-checkbox__inner{
                background-color: #1a46c4;
                border-color: #1a46c4;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// Login.vue?83c8f2fe